import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { CorporatePageHeading } from "./CorporatePageHeading";
import { CorporatePageContent } from "./CorporatePageContent";
import { CorporateNextPage } from "./CorporateNextPage";

export const Corporate = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label:"Page Heading",
      key: "corporatePageHeading",
      children: <CorporatePageHeading/>
    },
    {
      label:"Page Content",
      key: "corporatePageContent",
      children: <CorporatePageContent/>
    },
    {
      label:"Next Page",
      key: "corporateNextPage",
      children: <CorporateNextPage/>
    }
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
